export default __webpack_public_path__ + "static/legal_assistance-824a5ae8a546a952c3577faacdd98889.png";